import * as ImageSize from "utils/ImageSize";
import generateImageLink from "utils/generateImageLink";
import generatePosterUrlFromVideoRoot from "utils/generatePosterUrlFromVideoRoot";
import getVideoRoot from "selectors/getVideoRoot";
import { createSelector } from "reselect";
import getIsMobile from "selectors/device/getIsMobile";

const getIs360 = (state, ownProps) => {
  if (ownProps.videoId) {
    return !!state.story.entities.videos[ownProps.videoId].is360;
  }
  throw new Error("videoId is not specified in props");
};

const makeGetPosterUrl = () =>
  createSelector(
    [getIs360, getIsMobile, getVideoRoot],
    (is360, isMobile, videoRoot) => {
      const rawUrl = generatePosterUrlFromVideoRoot(videoRoot);

      let imageSize = ImageSize.LARGE;
      if (is360) {
        imageSize = ImageSize.EXTRA_LARGE;
      }

      return generateImageLink(rawUrl, {
        dpr: 1,
        isMobile,
        size: imageSize,
      });
    },
  );

export default makeGetPosterUrl;
